const styles = {
  headerContainer: {
    display: 'flex',
    flexBasis: '100%',
  },
};

export default styles;
